import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import reviewLetter from './images/ic_review-letter.svg';
import declineLetter from './images/ic_decline-letter.svg';

import './EarnMessage.css';

const EarnMessage = ({ type, children }) => {
  const renderImage = () => {
    switch(type) {
      case 'in_review':
        return (
          <img src={reviewLetter} alt="" />
        );
      case 'declined':
        return (
          <img src={declineLetter} alt="" />
        );
      default:
        return null;
    }
  };
  const { t } = useTranslation();
  return (
    <div className="earn-message__component">
      <div className="earn-message-wrapper">
        {children &&
          <h3>{children}</h3>
        }
        <p>{t("Please reach out to")} <a href="mailto:team@heylink.me">team@heylink.me</a> {t("if there are any questions.")}</p>

        {renderImage()}
      </div>
    </div>
  );
};

EarnMessage.propTypes = {
  type: PropTypes.oneOf(['in_review', 'declined']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
};
EarnMessage.defaultProps = {
  type: null,
  children: null,
};

export default EarnMessage;
